import { LorawanActionTypes } from '@utils/deviceActions';

const loraWanModels = (
  actionKey?: LorawanActionTypes,
  hasNewLora?: boolean,
) => {
  const model = ['devEui'];
  if (actionKey === LorawanActionTypes.CHANGE_DESCRIPTION) {
    model.push('description');
  } else if (actionKey === LorawanActionTypes.CHANGE_TAGS) {
    model.push('tags');
  } else if (actionKey === LorawanActionTypes.TRANSFER) {
    model.push('newCustomerVirtualAccountId');
  } else if (actionKey === LorawanActionTypes.DOWNLINK_SCHEDULE) {
    model.push(
      ...(hasNewLora
        ? ['payloadHex', 'confirmed', 'fPort', 'flushDownlinkQueue']
        : ['base64Payload', 'confirmed', 'port']),
    );
  } else if (actionKey === LorawanActionTypes.CONNECTING_LINK) {
    model.push('connections', 'linkMode');
  }
  return model;
};

export default loraWanModels;
